// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__TwaFR","notes":"Notes_notes__1z8pv"};